<template>
  <div id="container" ref="mapRef" class="mainBox">
    <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
    <div class="container">
    <Nav curNavId="4" pathUrl='qihouYj' @circle="clickNav" />
    <div class="left_txt">
      <div class="l_t_top">
        <div class="t_bt">
          <h5>种植模型数据采集</h5>
          <span></span>
          <span class="gs"></span>
        </div>
        <div class="t_down">
          <div class="t_d_t">
            <span></span>
            <h6>选择区域：</h6>
            <div class="srk">
              河南省驻马店市上蔡县
              <div class="contentLine contentLine1"></div>
              <div class="contentLine contentLine2"></div>
              <div class="contentLine contentLine3"></div>
              <div class="contentLine contentLine4"></div>
            </div>
            <div class="triangle"></div>
          </div>
          <div class="t_d_b">
            <span></span>
            <h6>选择分类：</h6>
            <div class="srk">
              小麦
              <div class="contentLine contentLine1"></div>
              <div class="contentLine contentLine2"></div>
              <div class="contentLine contentLine3"></div>
              <div class="contentLine contentLine4"></div>
            </div>
            <div class="triangle"></div>
          </div>
          <div class="t_d_d">
            <span></span>
            <h6>选择品类：</h6>
            <div class="srk">
              新麦45
              <div class="contentLine contentLine1"></div>
              <div class="contentLine contentLine2"></div>
              <div class="contentLine contentLine3"></div>
              <div class="contentLine contentLine4"></div>
            </div>
            <div class="triangle"></div>
          </div>
          <div class="t_d_d1">
            <div class="t_d_d1_l">
              <h5>地块管理</h5>
              <div class="d1_xtb"></div>
            </div>
            <div class="t_d_d1_r" @click="clickFangan">
              <h5>生成方案</h5>
              <div class="d1_xtb"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="l_t_down">
        <div class="t_bt">
          <h5>种植模型数据采集</h5>
          <span></span>
          <span class="gs"></span>
        </div>
        <div class="l_t_d_m">
          <div  class="l_t_d_m_g" :class="{l_t_d_m_g_cur:leftData1Cur==index}" v-for="(item,index) in leftData1" :key="index" @click="leftTab1(index)">{{item.name}}</div>
          <!-- <div class="l_t_d_m_g">生长记录</div>
          <div class="l_t_d_m_g">种植方案</div> -->
        </div>
        <div class="scrollTable">
          <dv-scroll-board :config="leftData1[leftData1Cur].config" style="width: 100%; height: 100%" />
        </div>
      </div>
    </div>
    <div class="right_txt">
      <div class="right_txt_top">
        <div class="xm_bg">
          <dv-border-box-8 :dur="4" :reverse="true">
            <img :src="plant[curLeftIndex].img" />
          </dv-border-box-8>
        </div>
        <div class="kqwd" :style="{ transform: `translateY(${offset}px)` }">
          <span class="f_g_bg"></span>
          <span></span>
          <h6>{{centerdata[0]}}℃</h6>
          <h5>空气温度</h5>
        </div>
        <div class="trsd" :style="{ transform: `translateY(${offset1}px)` }">
          <span class="f_g_bg"></span>
          <span></span>
          <h6>{{centerdata[1]}}%</h6>
          <h5>土壤湿度</h5>
        </div>
        <div class="gzqd" :style="{ transform: `translateY(${offset2}px)` }">
          <span class="f_g_bg"></span>
          <span></span>
          <h6>{{centerdata[2]}}lux</h6>
          <h5>光照强度</h5>
        </div>
        <div class="fs" :style="{ transform: `translateY(${offset}px)` }">
          <span class="f_g_bg"></span>
          <span></span>
          <h6>{{centerdata[3]}}m/s</h6>
          <h5>风速</h5>
        </div>
        <div class="jyl" :style="{ transform: `translateY(${offset3}px)` }">
          <span class="f_g_bg"></span>
          <span></span>
          <h6>{{centerdata[4]}}mm</h6>
          <h5>降雨量</h5>
        </div>
        <div class="trwd" :style="{ transform: `translateY(${offset2}px)` }">
          <span class="f_g_bg"></span>
          <span></span>
          <h6>{{centerdata[5]}}℃</h6>
          <h5>土壤温度</h5>
        </div>

        <div class="plant">
          <el-tabs
            v-model="activeName"
            class="demo-tabs"
            @tab-click="handleClick"
            id="tabs"
          >
            <el-tab-pane
              v-for="(item, index) in plant"
              :key="index"
              :label="item.name"
              :name="index"
            >
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="right_txt_down">
        <div class="right_txt_down_bt">
          <div class="down_dh"><router-link :to="{path:'/binghai'}">虫情监测站</router-link></div>
          <div class="down_dh"><router-link :to="{path:'/zhinengGG'}">固定喷灌</router-link></div>
          <div class="down_dh"><router-link :to="{path:'/plant'}">作物分析</router-link></div>
          <div class="down_dh"><router-link :to="{path:''}">种植规划</router-link></div>
        </div>
      </div>
    </div>
    </div>
  </div>
  <!-- 方案 -->
  <div class="popBg animate__animated animate__zoomIn" @click.stop="hiddlen"  v-if="faSHow" >
    <div class="faCon"  @click.stop="hiddlen1" >
      <div class="close" @click.stop="hiddlen">×</div>
      <div class="faInfo"><dv-scroll-board :config="config" style="width: 100%; height: 100%" /></div>
    </div>
  </div>
 <div class="footer">本产品由来村网提供技术支持</div>
  <CircleNav :isShow="circleShow"  @closeCircle1="circleHiddlen"  />
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
} from "vue";

// todo 项目使用请放开 leaflet 引入

// import * as L from 'leaflet/dist/leaflet.esm.js';
import footer1 from "../components/footer.vue";
import Nav from "../components/nav.vue";
import CircleNav from "@/components/circleNav.vue";
export default {
  name: "Home",
  setup() {
    // const timer = ref(null);
    const router = useRouter();

    const state = reactive({
      leftData1:[
        {
          name:"生长记录",
          config: {
            header: [
              '<span style="color:#fff;">农情</span>',
              '<span style="color:#fff;">项目</span>',
              '<span style="color:#fff;">记录</span>',
            ],

            data: [
              ["10-17", "播种环节农机服务", "灭茬45元/亩/次 1次 撒有机肥35元/亩/次 1次  深耕40元/亩/次 1次  旋地35元/亩/次 2次   种肥同播50元/亩/次 1次  震压10元/亩/次  1次"],
              ["10-21", "施肥", "羊粪700元/吨 400-600斤/亩 澳佳微生物肥 2500元/吨 70kg/亩  ETS菌肥1158元/吨 澳佳13-18-15 t3950元/吨 t120斤/亩 骏华25-13-7 3850元/吨 100斤/亩 鲁西15-15-15 3980元/吨 100斤/亩"],
              ["10-21", "播种", "40斤/亩 新麦45 3.6元/斤"],
              ["11-05", "蒙头水灌溉", "卷盘和人工喷灌\t60元/亩\t1次\n" +
              "\t80元/亩\t1次\n" +
              "平移式喷灌\t\t2次"],
              ["02-04", "越冬水灌溉", "骏华第十六元素\\t2850元/吨\\t30斤/亩\\n澳佳乌金氮\\t3050元/吨\\t30斤/亩\\n播肥机\\t12元/亩\\t1次"],
              ["02-27", "打药", "\"药品1：美丰麦笑（双氟·氯氟吡）+锐耙（2甲4氯钠）+亨达超克（联苯·噻虫嗪）\n" +
              "药品2：酷佬（2甲·双氟·唑）+闪净（联菊·啶虫脒）+恋神奇（碳机硅）\"\n" +
              "多花黑麦草除草剂：美丰瑞丰年（20%甲基二磺隆·异丙隆）+美丰无止境（哗咻草醋）\n" +
              "除草剂、杀虫剂\t12元/亩\t1次\n" +
              "机械\t8元/亩\t\n" +
              "多花黑麦草\t50元/亩\t1次\n" +
              "机械\t8元/亩\t"],
              ["03-09", "打药", "\"药品1：利尔作物·独功（氯氟·毒死蜱）+乐奥多·微量元素水溶肥料+利尔作物·普伴（24-表芸苔素内脂）+赛都优（氨基寡糖素）\n" +
              "药品2：六夫丁·快守（高效氯氟氰菊酯）+澳佳·活力丰（腐殖酸钾）+佳运（24-表芸苔素内脂）+优植康·清辞（寡糖·吗胍）\"\n" +
              "一喷三防\t18元/亩/次\t1次"],
              ["03-14", "返青水灌溉", "卷盘和人工喷灌\t60元/亩\t1次\n" +
              "\t80元/亩\t1次\n" +
              "平移式喷灌\t\t2次"],
              ["4.15","一喷三防","氰烯菌酯（戊唑醇、丙硫菌唑、氟唑菌酰羟胺、丙唑·戊唑醇、烯唑醇、己唑醇）+噻虫嗪（啶虫脒、吡蚜酮、抗蚜威）+氨基寡糖素（芸苔素、赤·吲乙·芸苔）"]
            ],
            headerBGC: "#274547",
            oddRowBGC: "",
            evenRowBGC: "",
            index: false,
            columnWidth: [100,100],
            align: ["center","center","center"],
            // rowNum:6
          },
        },
        {
          name:"种植方案",
          config: {
            header: [
              '<span style="color:#fff;">日期</span>',
              '<span style="color:#fff;">农事</span>',
              '<span style="color:#fff;">具体操作</span>',
            ],
            data:[
              ["10-17", "播种环节农机服务", "灭茬45元/亩/次 1次 撒有机肥35元/亩/次 1次  深耕40元/亩/次 1次  旋地35元/亩/次 2次   种肥同播50元/亩/次 1次  震压10元/亩/次  1次"],
              ["10-21", "施肥", "羊粪700元/吨 400-600斤/亩 澳佳微生物肥 2500元/吨 70kg/亩  ETS菌肥1158元/吨 澳佳13-18-15 t3950元/吨 t120斤/亩 骏华25-13-7 3850元/吨 100斤/亩 鲁西15-15-15 3980元/吨 100斤/亩"],
              ["10-21", "播种", "40斤/亩 新麦45 3.6元/斤"],
              ["11-05", "蒙头水灌溉", "卷盘和人工喷灌\t60元/亩\t1次\n" +
              "\t80元/亩\t1次\n" +
              "平移式喷灌\t\t2次"],
              ["02-04", "越冬水灌溉", "骏华第十六元素\\t2850元/吨\\t30斤/亩\\n澳佳乌金氮\\t3050元/吨\\t30斤/亩\\n播肥机\\t12元/亩\\t1次"],
              ["02-27", "打药", "\"药品1：美丰麦笑（双氟·氯氟吡）+锐耙（2甲4氯钠）+亨达超克（联苯·噻虫嗪）\n" +
              "药品2：酷佬（2甲·双氟·唑）+闪净（联菊·啶虫脒）+恋神奇（碳机硅）\"\n" +
              "多花黑麦草除草剂：美丰瑞丰年（20%甲基二磺隆·异丙隆）+美丰无止境（哗咻草醋）\n" +
              "除草剂、杀虫剂\t12元/亩\t1次\n" +
              "机械\t8元/亩\t\n" +
              "多花黑麦草\t50元/亩\t1次\n" +
              "机械\t8元/亩\t"],
              ["03-09", "打药", "\"药品1：利尔作物·独功（氯氟·毒死蜱）+乐奥多·微量元素水溶肥料+利尔作物·普伴（24-表芸苔素内脂）+赛都优（氨基寡糖素）\n" +
              "药品2：六夫丁·快守（高效氯氟氰菊酯）+澳佳·活力丰（腐殖酸钾）+佳运（24-表芸苔素内脂）+优植康·清辞（寡糖·吗胍）\"\n" +
              "一喷三防\t18元/亩/次\t1次"],
              ["03-14", "返青水灌溉", "卷盘和人工喷灌\t60元/亩\t1次\n" +
              "\t80元/亩\t1次\n" +
              "平移式喷灌\t\t2次"],
              ["04-15","一喷三防","氰烯菌酯（戊唑醇、丙硫菌唑、氟唑菌酰羟胺、丙唑·戊唑醇、烯唑醇、己唑醇）+噻虫嗪（啶虫脒、吡蚜酮、抗蚜威）+氨基寡糖素（芸苔素、赤·吲乙·芸苔）"],
                ["05-05","打药","氰烯菌酯（戊唑醇、丙硫菌唑、氟唑菌酰羟胺、丙唑·戊唑醇、烯唑醇、己唑醇）+噻虫嗪（吡蚜酮、抗蚜威）+氨基寡糖素（芸苔素内酯）"],
                ["06-01","收割","14.5%水分-585.6公斤/亩，成熟"]
            ],
            headerBGC: "#274547",
            oddRowBGC: "",
            evenRowBGC: "",
            index: false,
            columnWidth: [100,100],
            align: ["center","center","center"],
            // rowNum:6
          },
        }
      ],
      leftData1Cur:0,
      
      plant: [
        {
          name: "备播期",
          img: require("@/assets/img/plantmoxing/bbq.png"),
        },
        {
          name: "播种期",
          img: require("@/assets/img/plantmoxing/new/2.webp"),
        },
        {
          name: "岀苗期",
          img: require("@/assets/img/plantmoxing/new/3.jpeg"),
        },
        {
          name: "分蘖期",
          img: require("@/assets/img/plantmoxing/new/4.webp"),
        },
        {
          name: "越冬期",
          img: require("@/assets/img/plantmoxing/new/5.jpeg"),
        },
        {
          name: "返靑期",
          img: require("@/assets/img/plantmoxing/new/6.png"),
        },
        {
          name: "起身期",
          img: require("@/assets/img/plantmoxing/new/7.webp"),
        },
        {
          name: "拔节期",
          img: require("@/assets/img/plantmoxing/new/8.png"),
        },
        {
          name: "抽穗期",
          img: require("@/assets/img/plantmoxing/new/9.webp"),
        },
        {
          name: "开花期",
          img: require("@/assets/img/plantmoxing/new/10.jpeg"),
        },
        {
          name: "灌浆期",
          img: require("@/assets/img/plantmoxing/new/11.png"),
        },
        {
          name: "成孰期",
          img: require("@/assets/img/plantmoxing/new/12.webp"),
        },
        {
          name: "收获期",
          img: require("@/assets/img/plantmoxing/new/13.png"),
        },
      ],
      curLeftIndex: 0,
      offset: 0,
      direction: 1, // 1表示向下移动，-1表示向上移动
      speed: 1, // 移动速度
      offset1: 0,
      direction1: 1, // 1表示向下移动，-1表示向上移动
      speed1: 1.2, // 移动速度
      offset2: 0,
      direction2: 1, // 1表示向下移动，-1表示向上移动
      speed2: 1.4, // 移动速度
      offset3: 0,
      direction3: 1, // 1表示向下移动，-1表示向上移动
      speed3: 1.5, // 移动速度
      config: {
        header: [
          '<span style="color:#fff;">农情</span>',
          '<span style="color:#fff;">项目</span>',
          '<span style="color:#fff;">记录</span>',
        ],

        data: [
              ["10-17", "播种环节农机服务", "灭茬45元/亩/次 1次 撒有机肥35元/亩/次 1次  深耕40元/亩/次 1次  旋地35元/亩/次 2次   种肥同播50元/亩/次 1次  震压10元/亩/次  1次"],
              ["10-21", "施肥", "羊粪700元/吨 400-600斤/亩 澳佳微生物肥 2500元/吨 70kg/亩  ETS菌肥1158元/吨 澳佳13-18-15 t3950元/吨 t120斤/亩 骏华25-13-7 3850元/吨 100斤/亩 鲁西15-15-15 3980元/吨 100斤/亩"],
              ["10-21", "播种", "40斤/亩 新麦45 3.6元/斤"],
              ["11-05", "蒙头水灌溉", "卷盘和人工喷灌\t60元/亩\t1次\n" +
              "\t80元/亩\t1次\n" +
              "平移式喷灌\t\t2次"],
              ["02-04", "越冬水灌溉", "骏华第十六元素\\t2850元/吨\\t30斤/亩\\n澳佳乌金氮\\t3050元/吨\\t30斤/亩\\n播肥机\\t12元/亩\\t1次"],
              ["02-27", "打药", "\"药品1：美丰麦笑（双氟·氯氟吡）+锐耙（2甲4氯钠）+亨达超克（联苯·噻虫嗪）\n" +
              "药品2：酷佬（2甲·双氟·唑）+闪净（联菊·啶虫脒）+恋神奇（碳机硅）\"\n" +
              "多花黑麦草除草剂：美丰瑞丰年（20%甲基二磺隆·异丙隆）+美丰无止境（哗咻草醋）\n" +
              "除草剂、杀虫剂\t12元/亩\t1次\n" +
              "机械\t8元/亩\t\n" +
              "多花黑麦草\t50元/亩\t1次\n" +
              "机械\t8元/亩\t"],
              ["03-09", "打药", "\"药品1：利尔作物·独功（氯氟·毒死蜱）+乐奥多·微量元素水溶肥料+利尔作物·普伴（24-表芸苔素内脂）+赛都优（氨基寡糖素）\n" +
              "药品2：六夫丁·快守（高效氯氟氰菊酯）+澳佳·活力丰（腐殖酸钾）+佳运（24-表芸苔素内脂）+优植康·清辞（寡糖·吗胍）\"\n" +
              "一喷三防\t18元/亩/次\t1次"],
              ["03-14", "返青水灌溉", "卷盘和人工喷灌\t60元/亩\t1次\n" +
              "\t80元/亩\t1次\n" +
              "平移式喷灌\t\t2次"],
          ["04-15","一喷三防","氰烯菌酯（戊唑醇、丙硫菌唑、氟唑菌酰羟胺、丙唑·戊唑醇、烯唑醇、己唑醇）+噻虫嗪（啶虫脒、吡蚜酮、抗蚜威）+氨基寡糖素（芸苔素、赤·吲乙·芸苔）"]
            ],
        headerBGC: "#15364D",
        oddRowBGC: "",
        evenRowBGC: "",
        index: false,
        columnWidth: [200,200],
        align: ["center","center","center"],
        rowNum:12,
      },
      faSHow:false,
      activeName: 0,
      centerdata:[],
      circleShow:false
    });

    // 在 onMounted 中初始化地图
    onMounted(() => {
      animate();
      getData()
    });
    // 数据
     
    function getData(){
        axios
          .get("https://zhfarm.laicunwang.com/api/environment/shangcaiqxCachedata", {sign:"c4c6cff9b7ec6b87fa953f77ec7e624b"})
          .then((res) => {
              console.log(res);
              state.centerdata.push(res.data.data.data1.lastDatas[0].air_temperature)
              state.centerdata.push(res.data.data.data2.lastDatas[0].soil_moisture)
              state.centerdata.push(res.data.data.data1.lastDatas[0].light_intensity)
              state.centerdata.push(res.data.data.data1.lastDatas[0].wind_direction)
              state.centerdata.push(res.data.data.data1.lastDatas[0].rainfall)
              state.centerdata.push(res.data.data.data2.lastDatas[0].soil_temperature)
              console.log(state.centerdata)
          });
    }
    // 关闭生成方案
    function hiddlen(){
      state.faSHow = false
    }
    // 生成方案
    function clickFangan(){
      state.faSHow = true
    }
    // 左侧切换
    function leftTab1(index){
      state.leftData1Cur = index
    }
    function animate() {
      setInterval(() => {
        state.offset += state.direction * state.speed;
        state.offset1 += state.direction1 * state.speed1;
        state.offset2 += state.direction2 * state.speed2;
        state.offset3 += state.direction3 * state.speed3;

        // 当移动到边界时反转方向
        if (state.offset >= 16 || state.offset <= -16) {
          state.direction *= -1;
        }
        if (state.offset1 >= 15 || state.offset1 <= -15) {
          state.direction1 *= -1;
        }
        if (state.offset2 >= 14 || state.offset2 <= -14) {
          state.direction2 *= -1;
        }
        if (state.offset3 >= 16 || state.offset3 <= -16) {
          state.direction3 *= -1;
        }

        // Vue3中不需要$forceUpdate，因为响应式系统会自动更新视图
      }, 100); // 动画速度根据实际情况调整（这里是每100毫秒执行一次）
    }

    // 返回上一页
    function clickReturn() {
      router.go(-1);
    }
    function handleClick(tab, e) {
      // console.log(tab.index)
      state.curLeftIndex = tab.index;
      console.log(state.curLeftIndex);
    }
    function clickNav(isShow){
      // console.log(isShow)
      state.circleShow = isShow.show
    }
    function circleHiddlen(data1){
      // console.log('circle')
      state.circleShow = data1.show
    }
    onUnmounted(() => {});
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });

    return {
      ...toRefs(state),
      leftTab1,
      clickReturn,
      handleClick,
      clickFangan,
      hiddlen,
      getData,
      clickNav,
      circleHiddlen
    };
  },
  components: { CircleNav, footer1,Nav},
};
</script>
<style lang="less" scoped>
 .footer{
    width: 100%;
    height: 30px;
    line-height: 30px;
    color: #fff;
    text-align: right;
    font-size: 14px;
    position: fixed;
    bottom: 10px;
    right: 0;
    z-index: 10000;
    font-weight: bold;
    padding-right: 3%;
    box-sizing: border-box;
    }
// 方案
.popBg{
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0,0,0,.5);
  top: 0;
  left: 0;
  z-index: 999;
  transition: all 0.5s ease-out;
  .faCon{
    width: 50%;
    height:70%;
    position: absolute;
    top: 15%;
    left: 25%;
    background: #102130;
    // border: 2px solid;
    border: 2px solid #16616A;
    display: flex;
    flex-direction: column;
    padding: 10px 20px;
    box-sizing: border-box;
    align-items: center;
    .close{
      color: rgba(255,255,255,.8);
      font-size: 30px;
      position: absolute;
      top: 10px;
      right: 16px;
      cursor: pointer;
    }
    .faInfo{
      width: 90%;
      flex: 1;
      margin-top: 30px;
      font-size: 14px;
    }
  }
}
body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep .el-tabs__nav-wrap.is-scrollable{
  padding: 0 25px 0 25px;
}
::v-deep .el-tabs__item {
  width: 102px;
  height: 72px;
  padding: 0;
  // border: 1px solid #1a6266;
  display: flex;
  justify-content: center;

  align-items: self-start;
  position: relative;
  margin: 0 10px;
  flex-shrink: 0;
  box-sizing: border-box;
  color: #fff;
  background: url("../assets/img/plantmoxing/xz.png") no-repeat top center;
  background-size: 100% 100%;
}
::v-deep .el-tabs__item::before,
::v-deep .el-tabs__item::after {
  content: " ";
  background: #21fcff;
  width: 2px;
  height: 12px;
  position: absolute;
  top: 12px;
  background: url("../assets/img/plantmoxing/xz.png") no-repeat top center;
  background-size: 100% 100%;
}
::v-deep .el-tabs__item::before {
  left: -1px;
}
::v-deep .el-tabs__item::after {
  right: -1px;
}
::v-deep .el-tabs__nav {
  display: flex;
}
::v-deep .el-tabs__nav-wrap::after {
  display: none;
}
::v-deep .el-tabs__active-bar {
  width: 100%;
  background-color: #21fcff;
}
::v-deep .is-active {
  color: #a1c81f;
}
::v-deep .el-tabs__nav-prev {
  position: absolute;
  cursor: pointer;
  background: url("../assets/img/plantmoxing/zjt.png") no-repeat top center;
  background-size: 100% 100%;
  width: 18px;
  height: 23px;
  left: 1px;
  top: 8px;

  color: transparent; /* 文字颜色透明 */
}
::v-deep .el-tabs__nav-prev:hover {
  position: absolute;
  cursor: pointer;
  background: url("../assets/img/plantmoxing/zjt1.png") no-repeat top center;
  background-size: 100% 100%;
  width: 18px;
  height: 23px;
  left: 0;
  top: 8px;

  color: transparent; /* 文字颜色透明 */
}
::v-deep .el-tabs__nav-next {
  background: url("../assets/img/plantmoxing/zjt.png") no-repeat top center;
  background-size: 100% 100%;
  width: 18px;
  height: 23px;
  right: 0px;
  top: 8px;
  transform: scaleX(-1);
  color: transparent; /* 文字颜色透明 */
}
::v-deep .el-tabs__nav-next:hover {
  position: absolute;
  cursor: pointer;
  background: url("../assets/img/plantmoxing/zjt1.png") no-repeat top center;
  background-size: 100% 100%;
  width: 18px;
  height: 23px;
  right: 0px;
  top: 8px;
  transform: scaleX(-1);
  color: transparent; /* 文字颜色透明 */
}
.container{
  width: 100%;
  height: 100%;
   background: url("../assets/img/plantmoxing/bg2.png") no-repeat;
}
.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  position: absolute;
  background: url("../assets/img/plantmoxing/bj.png") no-repeat top center;
  background-size: 100% 100%;
  .containerBg {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url("../assets/img/gbzntyj/bg.png") no-repeat;
    z-index: 999;
  }

  .dh_wz {
    width: 170px;
    height: 47px;
    position: absolute;
    left: 3%;
    top: 20%;
    background: url("../assets/img/gbzntyj/yy.png") no-repeat top center;
    background-size: 100% 100%;

    .dh_wz_qq {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      position: absolute;
      top: 6px;
      left: 7px;
      border: 1px solid #ffc600; /* 添加一个黑色的边框 */
    animation: guangying 2s linear infinite;
    }
    .dh_wz_tb {
        width: 20px;
        height: 20px;
        position: absolute;
        left: 15px;
        top: 14px;
        background: url("../assets/img/gbzntyj/nt.png") no-repeat top center;
        background-size: 100% 100%;
        animation: topIcon 2s linear infinite;
      }
    .dh_wz_wz {
      width: 120px;
      height: 47px;
      line-height: 47px;
      color: #fff;
      font-size: 20px;
      font-weight: 500;
      text-align: center;
      position: absolute;
      right: 5%
    }
  }
  .topContent {
    width: 100%;
    height: 100px;
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    .titleRightImg {
      position: absolute;
      right: 0;
      top: 26%;
      .return {
        width: 77px;
        height: 32px;
        margin-right: 15px;
        cursor: pointer;
        position: relative;
        z-index: 999;
      }
    }
  }

  .dh_lb {
    // width: 900px;
    height: 45px;
    position: absolute;
    left: 23%;
    top: 20%;
    display: flex;
    flex-flow: row;
    a {
      text-decoration: none;
    }

    .dh_lb_bt {
      width: 124px;
      height: 43px;
      background: url("../assets/img/gbzntyj/yy.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #3bf4be;
      transition: all 0.5s ease-out;
    }
    .dh_lb_bt:hover,
    .dh_lb_bt_cur {
      width: 124px;
      height: 43px;
      cursor: pointer;
      background: url("../assets/img/gbzntyj/xz.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #fff;
    }
  }
  .left_txt {
    width: 570px;
    height: 88%;
    position: absolute;
    top: 11%;
    left: 3%;
    display: flex;
    flex-direction: column;
    z-index: 999;
    .t_bt {
      width: 100%;
      height: 89px;
      position: relative;
      h5 {
        width: 100%;
        height: 100%;
        position: absolute;
        font-size: 16px;
        line-height: 50px;
        letter-spacing: 5px;
        text-align: center;
        color: transparent; /* 隐藏文本本身的颜色 */
        background-image: linear-gradient(
          to bottom,
          #fbf8f2 20%,
          #FFD791
        ); /* 创建从红色到绿色的线性渐变背景 */
        // (to top, #fff 25%, #fff 55%, FFD791 95%);
        -webkit-background-clip: text; /* 将背景应用到文本上（仅限于Webkit内核浏览器） */
        background-clip: text; /* 将背景应用到文本上（现代浏览器支持） */
        -webkit-text-fill-color: transparent; /* 对Webkit内核浏览器隐藏文本颜色 */
      }
      span {
        width: 100%;
        height: 100%;
        background: url("../assets/img/plantmoxing/btk.png") no-repeat top
          center;
        background-size: 100% 100%;
        position: absolute;
        left: 0;
        top: 20px;
      }
      .gs {
        width: 80px;
        height: 20px;
        background: url("../assets/img/plantmoxing/gx.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        left: 245px;
        top: 39px;
        animation: left1Img 2s linear infinite;
      }
    }
    .l_t_top {
      width: 100%;
      height: 430px;
      // border: #3bf4be 1px solid;
      position: relative;

      .t_down {
        width: 100%;
        height: 340px;
        // border: #3bf4be 1px solid;
        display: flex;
        flex-direction: column;
        h6 {
          width: 110px;
          height: 51px;
          font-size: 14px;
          color: #fff;
          text-align: left;
          line-height: 51px;
          position: absolute;
          left: 40px;
          top: 0;
          letter-spacing: 5px;
        }
        .srk {
          width: 350px;
          height: 51px;
          background: url("../assets/img/plantmoxing/xzk.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          overflow: hidden;
          right: 80px;
          top: 0;
          font-size: 14px;
          color: #fff;
          line-height: 51px;
          text-align: left;
          letter-spacing: 4px;
          text-indent: 2em;
        }
        .triangle {
          width: 0;
          height: 0;
          border-style: solid;
          position: absolute;
          border-width: 9px 9px 0 9px; /* 上下左右四个边框宽度 */
          border-color: #829297 transparent transparent transparent; /* 边框颜色：上红 下透明 左透明 右透明 */
          right: 110px;
          top: 22px;
          display: none;
        }

        .t_d_t {
          width: 100%;
          height: 51px;
          margin: 10px 0;
          position: relative;
          span {
            width: 20px;
            height: 20px;
            background: url("../assets/img/plantmoxing/qy.png") no-repeat top
              center;
            background-size: 100% 100%;
            position: absolute;
            left: 5px;
            top: 15px;
          }
        }
        .t_d_b {
          width: 100%;
          height: 51px;
          margin: 10px 0;
          position: relative;
          span {
            width: 20px;
            height: 20px;
            background: url("../assets/img/plantmoxing/pl.png") no-repeat top
              center;
            background-size: 100% 100%;
            position: absolute;
            left: 5px;
            top: 15px;
          }
        }
        .t_d_d {
          width: 100%;
          height: 51px;
          margin: 10px 0;
          position: relative;
          span {
            width: 20px;
            height: 20px;
            background: url("../assets/img/plantmoxing/pz.png") no-repeat top
              center;
            background-size: 100% 100%;
            position: absolute;
            left: 5px;
            top: 15px;
          }
        }
        .t_d_d1 {
          width: 100%;
          height: 51px;
          margin-top: 30px;
          position: relative;

          h5 {
            width: 120px;
            height: 51px;
            font-size: 14px;
            color: #fff;
            text-align: center;
            line-height: 51px;
            letter-spacing: 4px;
          }

          .t_d_d1_l {
            width: 190px;
            height: 100%;
            background: url("../assets/img/plantmoxing/dkk.png") no-repeat top
              center;
            background-size: 100% 100%;
            position: absolute;
            left: 73px;
            .d1_xtb {
              width: 26px;
              height: 26px;
              background: url("../assets/img/plantmoxing/dkgl.png") no-repeat
                top center;
              background-size: 100% 100%;
              position: absolute;
              right: 22px;
              top: 10.5px;
            }
          }
          .t_d_d1_r {
            width: 190px;
            height: 100%;
            background: url("../assets/img/plantmoxing/dkk.png") no-repeat top
              center;
            background-size: 100% 100%;
            position: absolute;
            right: 80px;
            cursor: pointer;
            .d1_xtb {
              width: 26px;
              height: 26px;
              background: url("../assets/img/plantmoxing/scfa.png") no-repeat
                top center;
              background-size: 100% 100%;
              position: absolute;
              right: 22px;
              top: 10.5px;
            }
          }
        }
      }
    }
    .l_t_down {
      // border: #3bf4be 1px solid;
      flex: 1;
      .l_t_d_m {
        width: 100%;
        height: 43px;
        position: relative;
        top: -25px;
        left: 0;
        display: flex;
        justify-content: center;
        .l_t_d_m_g {
          width: 80px;
          height: 43px;
          font-size: 14px;
          line-height: 43px;
          color: #01e9e7;
          background: url("../assets/img/plantmoxing/szjl.png") no-repeat top
            center;
          background-size: 100% 100%;
          cursor: pointer;
          margin: 5px 50px 0;
        }
        .l_t_d_m_g_cur{
          color: #a1c81f;
        }

        // .l_t_d_m_l {
        //   left: 166px;
        // }
        // .l_t_d_m_r {
        //   right: 166px;
        // }
      }
      .scrollTable {
        width: 100%;
        height: 60%;
        // border: #fff 1px solid;
      }
    }
  }
  .right_txt {
    width: 1000px;
    height: 76%;
    top: 22%;
    // border: #01e9e7 1px solid;
    position: absolute;
    right: 10%;
    .right_txt_top {
      width: 100%;
      height: 80%;
      // border: #fff 1px solid;
      background: url("../assets/img/plantmoxing/lt.png") no-repeat top center;
      background-size: 100% 100%;
      position: absolute;
      .xm_bg {
        width: 450px;
        height: 45%;
        background: url(/img/tpk.f80a61e5.png) no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        top: 18%;
        left: 25%;

        img {
          width: 94%;
          height: 94%;
          margin: 1.5% 1.5%;
        }
      }
      .kqwd {
        width: 92px;
        height: 109px;
        background: url("../assets/img/plantmoxing/xk.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        left: 4.5%;
        top: -45px;
        .f_g_bg {
          width: 52px;
          height: 12px;
          background: url("../assets/img/plantmoxing/xgs.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: -3px;
          left: 19px;
          animation: left1Img 2s linear infinite;
        }
        span {
          width: 19px;
          height: 21px;
          background: url("../assets/img/plantmoxing/kq.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: 14px;
          left: 36.5px;
        }
        h6 {
          width: 100%;
          font-size: 14px;
          height: 25px;
          line-height: 25px;
          color: #02f6e3;
          position: absolute;
          top: 33px;
        }
        h5 {
          width: 100%;
          font-size: 14px;
          height: 25px;
          line-height: 25px;
          color: #02f6e3;
          position: absolute;
          top: 49px;
        }
      }
      .trsd {
        width: 123px;
        height: 143px;
        background: url("../assets/img/plantmoxing/dk.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        left: 17%;
        top: -19px;
        .f_g_bg {
          width: 52px;
          height: 12px;
          background: url("../assets/img/plantmoxing/xgs.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: -3px;
          left: 34px;
          animation: left1Img 2s linear infinite;
        }

        span {
          width: 23px;
          height: 23px;
          background: url("../assets/img/plantmoxing/tr.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: 16px;
          left: 47px;
        }
        h6 {
          width: 100%;
          font-size: 14px;
          height: 25px;
          line-height: 25px;
          color: #02f6e3;
          position: absolute;
          top: 41px;
        }
        h5 {
          width: 100%;
          font-size: 14px;
          height: 25px;
          line-height: 25px;
          color: #02f6e3;
          position: absolute;
          top: 60px;
        }
      }
      .gzqd {
        width: 92px;
        height: 109px;
        background: url("../assets/img/plantmoxing/xk.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        top: -56px;
        left: 37%;
        position: absolute;
        .f_g_bg {
          width: 52px;
          height: 12px;
          background: url("../assets/img/plantmoxing/xgs.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: -3px;
          left: 19px;
          animation: left1Img 2s linear infinite;
        }
        span {
          width: 19px;
          height: 21px;
          background: url("../assets/img/plantmoxing/gz.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: 14px;
          left: 36.5px;
        }
        h6 {
          width: 100%;
          font-size: 14px;
          height: 25px;
          line-height: 25px;
          color: #02f6e3;
          position: absolute;
          top: 33px;
        }
        h5 {
          width: 100%;
          font-size: 14px;
          height: 25px;
          line-height: 25px;
          color: #02f6e3;
          position: absolute;
          top: 49px;
        }
      }
      .fs {
        width: 123px;
        height: 143px;
        background: url("../assets/img/plantmoxing/dk.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        top: -64px;
        left: 52%;
        .f_g_bg {
          width: 52px;
          height: 12px;
          background: url("../assets/img/plantmoxing/xgs.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: -3px;
          left: 34px;
          animation: left1Img 2s linear infinite;
        }
        span {
          width: 23px;
          height: 23px;
          background: url("../assets/img/plantmoxing/fs.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: 16px;
          left: 47px;
        }
        h6 {
          width: 100%;
          font-size: 14px;
          height: 25px;
          line-height: 25px;
          color: #02f6e3;
          position: absolute;
          top: 41px;
        }
        h5 {
          width: 100%;
          font-size: 14px;
          height: 25px;
          line-height: 25px;
          color: #02f6e3;
          position: absolute;
          top: 60px;
        }
      }
      .jyl {
        width: 92px;
        height: 109px;
        background: url("../assets/img/plantmoxing/xk.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        top: -34px;
        left: 71%;
        .f_g_bg {
          width: 52px;
          height: 12px;
          background: url("../assets/img/plantmoxing/xgs.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: -3px;
          left: 19px;
          animation: left1Img 2s linear infinite;
        }
        span {
          width: 19px;
          height: 21px;
          background: url("../assets/img/plantmoxing/jyl.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: 14px;
          left: 36.5px;
        }
        h6 {
          width: 100%;
          font-size: 14px;
          height: 25px;
          line-height: 25px;
          color: #02f6e3;
          position: absolute;
          top: 33px;
        }
        h5 {
          width: 100%;
          font-size: 14px;
          height: 25px;
          line-height: 25px;
          color: #02f6e3;
          position: absolute;
          top: 49px;
        }
      }
      .trwd {
        width: 92px;
        height: 109px;
        background: url("../assets/img/plantmoxing/xk.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        top: -45px;
        left: 88%;
        .f_g_bg {
          width: 52px;
          height: 12px;
          background: url("../assets/img/plantmoxing/xgs.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: -3px;
          left: 19px;
          animation: left1Img 2s linear infinite;
        }
        span {
          width: 19px;
          height: 21px;
          background: url("../assets/img/plantmoxing/wd.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: absolute;
          top: 14px;
          left: 36.5px;
        }
        h6 {
          width: 100%;
          font-size: 14px;
          height: 25px;
          line-height: 25px;
          color: #02f6e3;
          position: absolute;
          top: 33px;
        }
        h5 {
          width: 100%;
          font-size: 14px;
          height: 25px;
          line-height: 25px;
          color: #02f6e3;
          position: absolute;
          top: 49px;
        }
      }

      .plant {
        width: 100%;
        height: 72px;
        position: absolute;
        // border: 1px salmon solid;
        left: 0;
        bottom: 1px;
      }
    }
    .right_txt_down {
      width: 750px;
      height: 90px;
      position: absolute;
      background: url("../assets/img/plantmoxing/bw.png") no-repeat top center;
      background-size: 100% 100%;
      bottom: -18px;
      left: 50%;
      margin-left: -375px;

      .right_txt_down_bt {
        width: 512px;
        height: 100%;
        display: flex;
        position: absolute;
        left: 119px;
        .down_dh {
          width: 88px;
          height: 43px;
          background: url("../assets/img/plantmoxing/szjl.png") no-repeat top
            center;
          background-size: 100% 100%;
          margin: 23px 20px;
          font-size: 14px;
          line-height: 43px;
          
          a{color: #fff;}
        }
      }
    }
  }
}
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes left1Img {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.3);
  }
  100% {
    transform: scale(1);
  }
}
.contentLine {
  background: #1aa19e;
  position: absolute;
}
.contentLine1 {
  top: 1px;
  left: 0;
  width: 10%;
  height: 2px;
  /* 加上渐变效果，方可形成拖尾效果 */
  background: linear-gradient(90deg, transparent, #1aa19e);
  animation: animate1 4s linear infinite;
}
.contentLine2 {
  top: -100%;
  right: 0;
  width: 2px;
  height: 20%;
  background: linear-gradient(180deg, transparent, #1aa19e);
  animation: animate2 4s linear infinite;
  /* 注意要加上延时触发动画效果，这样线条才会依次触发 */
  animation-delay: 1s;
}
.contentLine3 {
  bottom: 1px;
  right: 0;
  width: 20%;
  background: linear-gradient(270deg, transparent, #1aa19e);
  animation: animate3 4s linear infinite;
  animation-delay: 2s;
}
.contentLine4 {
  bottom: -100%;
  left: 1px;
  width: 2px;
  height: 10%;
  background: linear-gradient(360deg, transparent, #1aa19e);
  animation: animate4 4s linear infinite;
  animation-delay: 3s;
}
/* 定义关键帧 */
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}

@keyframes animate1 {
  0% {
    left: -50%;
  }

  50%,
  100% {
    left: 100%;
  }
}

@keyframes animate2 {
  0% {
    top: -100%;
  }

  50%,
  100% {
    top: 100%;
  }
}
@keyframes animate3 {
  0% {
    right: -100%;
    height: 3px;
  }

  50%,
  100% {
    height: 2px;
    right: 100%;
  }
}
@keyframes animate4 {
  0% {
    bottom: -100%;
  }

  50%,
  100% {
    bottom: 100%;
  }
}
@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
   100% {
    transform: rotate(0);
  }
}
</style>
